import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IGetDirectorsResponse } from '../models/get-directors.model';
import { fromGetDirectorsActions } from '../actions';

export const getDirectorsFeatureKey = 'getDirectors';

export interface GetDirectorsState {
  loadGetDirectorsResponse: IGetDirectorsResponse[];
  loadGetDirectorsFailure: IGenericError<ErrorResponse>;
}

export const initialState: GetDirectorsState = {
  loadGetDirectorsResponse: undefined,
  loadGetDirectorsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromGetDirectorsActions.loadGetDirectorsSuccess, (state, action) => ({
    ...state,
    loadGetDirectorsResponse: action.response
  })),
  on(fromGetDirectorsActions.loadGetDirectorsFailure, (state, action) => ({
    ...state,
    loadGetDirectorsFailure: action.error
  })),
  on(fromGetDirectorsActions.clearGetDirectorsSuccess, (state, action) => ({
    ...state,
    loadGetDirectorsResponse: undefined
  }))
);

export const getDirectorsResponse = (state: GetDirectorsState) => state.loadGetDirectorsResponse;
export const getDirectorsFailure = (state: GetDirectorsState) => state.loadGetDirectorsFailure;
